import React from 'react';
import { useDispatch } from 'react-redux';
import {
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableBody,
} from '@mui/material';

import {
  closeModalByNameAction,
  PlainModals,
} from 'store/modules/modals/modals.reducer';
import {
  StyledTableBodyCell,
  StyledTableHeaderCell,
} from 'components/table/styles';
import {
  useGetModalMetaData,
  useIsPlainModalOpenSelector,
} from 'store/modules/modals/modals.selector';
import { ModalContainer } from 'components/modals/modal-container/modal-container';

export const PackageAdvisoryModal = () => {
  const dispatch = useDispatch();
  const metaData = useGetModalMetaData();

  //@ts-ignore
  const advisory: ExternalPackagesAdvisoryItem[] = metaData?.advisory;

  const isAdvisoryModal = useIsPlainModalOpenSelector(
    PlainModals.PACKAGE_ADVISORY_MODAL,
  );

  const handleCloseModal = () => {
    dispatch(closeModalByNameAction(PlainModals.PACKAGE_ADVISORY_MODAL));
  };

  return (
    <ModalContainer
      isOpenModal={isAdvisoryModal}
      title="Advisory"
      modalWidth="700px"
      modalHeight="400px"
      handleCloseModal={handleCloseModal}
    >
      <TableContainer sx={{ marginTop: '25px', maxHeight: '750px' }}>
        <Table
          stickyHeader
          sx={{ minWidth: '550px', backgroundColor: 'transparent' }}
          size="small"
        >
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell align="left">
                Summary
              </StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {advisory?.map((item, index) => (
              <TableRow key={index}>
                <StyledTableBodyCell align="left">
                  {item.summary}
                </StyledTableBodyCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ModalContainer>
  );
};
